import { EMPTY_STRING } from '../../../../../../../constants/common'

export function getRequestWizardCardStageInputValueProps(field) {
  return {
    value: field.value ?? EMPTY_STRING, // in request wizard at first Formik render we get initial value undefined, so we need a default empty value for that case
  }
}
